import {Injectable} from "@angular/core";
import {NavigationEnd, Router, RoutesRecognized} from "@angular/router";
import {Observable, Subject} from "rxjs";
import {delay, filter, map, pairwise} from "rxjs/operators";

@Injectable({providedIn: "root"})
export class SameUrlNavigationDetector {

	private sameUrlDetected$: Subject<[NavigationEnd, NavigationEnd]> = new Subject<[NavigationEnd, NavigationEnd]>();

	constructor(private router: Router) {
	}

	init() {
		this.router.events.pipe(
			filter(event => event instanceof NavigationEnd),
			map(event => event as NavigationEnd),
			pairwise(),
			filter(events => this.areSameUrls(events))
		).subscribe(events => {
			this.sameUrlDetected$.next(events);
		});
	}

	detect(): Observable<[NavigationEnd, NavigationEnd]> {
		return this.sameUrlDetected$.asObservable();
	}

	private areSameUrls(navigation: [NavigationEnd, NavigationEnd]) {
		const navigatedFrom = this.removeQueryParams(navigation[0].url);
		const navigatedTo = this.removeQueryParams(navigation[1].url);
		return navigatedFrom === navigatedTo;
	}

	private removeQueryParams(url: string): string {
		let index = url.lastIndexOf('?');
		return index >= 0 ? url.substring(0, index) : url;
	}
}
